import React from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

export interface CSSZTakeoverValues {
	decisionNumber: string;
}

interface Props {
	onSubmit: (values: CSSZTakeoverValues) => void;
	disableSubmit: boolean;
}

const CSSZSickLeaveCertificateTakeoverForm = ({
	onSubmit,
	disableSubmit,
}: Props) => {
	const formScheme: ItemScheme[] = [
		{
			type: MagicField.TEXT_FIELD,
			key: 'decisionNumber',
			title: 'component.CSSZSickLeaveCertificateForm.DPNDecisionNumber',
			defaultValue: '',
			settings: {
				required: true,
				errorMessage:
					'validation.CSSZSickLeaveCertificateTakeoverForm.decisionNumber',
				rules: [
					{
						type: 'min',
						value: 18,
						message:
							'validation.CSSZSickLeaveCertificateTakeoverForm.decisionNumberLength',
					},
					{
						type: 'maxLength',
						value: 18,
						message:
							'validation.CSSZSickLeaveCertificateTakeoverForm.decisionNumberLength',
					},
				],
			},
		},
	];

	return (
		<MagicForm
			formScheme={formScheme}
			disableSubmit={disableSubmit}
			onSubmit={onSubmit}
			submitText={'base.shared.form.send'}
		/>
	);
};

export default CSSZSickLeaveCertificateTakeoverForm;
